<template>
  <div class="s-block-area" :class="{ 'is-disabled': active }">
    <!-- 原始內容 -->
    <div class="s-block-area__content">
      <slot />
    </div>

    <!-- 遮罩層 -->
    <div v-if="active" class="s-block-area__overlay">
      <!-- 圖示或文字顯示區域 -->
      <div
        v-if="text || $slots.text"
        class="s-block-area__indicator"
      >
        <slot name="text">
          <span v-if="text" class="s-block-area__text">{{ text }}</span>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BlockArea',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
})

</script>

<style lang="postcss">
.s-block-area {
  @apply relative;

  &.is-disabled {
    .s-block-area__content {
      @apply pointer-events-none select-none;
    }
  }
}

.s-block-area__content {
  @apply relative z-[1];
}

.s-block-area__overlay {
  @apply absolute inset-0 z-[2] flex items-center justify-center rounded-sm;
  @apply backdrop-blur-[1.5px];
  background: rgba(0, 0, 0, 0.2);
}

.s-block-area__indicator {
  @apply flex flex-col items-center gap-2;
}

.s-block-area__text {
  @apply text-sm font-medium;
}
</style>
